/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const AgendaCommercialeDtoEsitoEnum = {
    Annullata: 'ANNULLATA',
    Positivo: 'POSITIVO',
    Negativo: 'NEGATIVO',
    Neutro: 'NEUTRO',
    DaEseguire: 'DA_ESEGUIRE'
};
/**
 * @export
 */
export const AgendaCommercialeDtoModalitaContattoEnum = {
    Mail: 'MAIL',
    Telefono: 'TELEFONO',
    Incontro: 'INCONTRO'
};
/**
 * Check if a given object implements the AgendaCommercialeDto interface.
 */
export function instanceOfAgendaCommercialeDto(value) {
    return true;
}
export function AgendaCommercialeDtoFromJSON(json) {
    return AgendaCommercialeDtoFromJSONTyped(json, false);
}
export function AgendaCommercialeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'creationDate': json['creationDate'] == null ? undefined : (new Date(json['creationDate'])),
        'lastmodifiedDate': json['lastmodifiedDate'] == null ? undefined : (new Date(json['lastmodifiedDate'])),
        'fkCliente': json['fkCliente'] == null ? undefined : json['fkCliente'],
        'fkStrutturaBusiness': json['fkStrutturaBusiness'] == null ? undefined : json['fkStrutturaBusiness'],
        'fkProject': json['fkProject'] == null ? undefined : json['fkProject'],
        'fkOpportunity': json['fkOpportunity'] == null ? undefined : json['fkOpportunity'],
        'fkUtente': json['fkUtente'] == null ? undefined : json['fkUtente'],
        'actionDate': json['actionDate'] == null ? undefined : (new Date(json['actionDate'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'margin': json['margin'] == null ? undefined : json['margin'],
        'nota': json['nota'] == null ? undefined : json['nota'],
        'notaEsito': json['notaEsito'] == null ? undefined : json['notaEsito'],
        'nominativoCliente': json['nominativoCliente'] == null ? undefined : json['nominativoCliente'],
        'esito': json['esito'] == null ? undefined : json['esito'],
        'modalitaContatto': json['modalitaContatto'] == null ? undefined : json['modalitaContatto'],
    };
}
export function AgendaCommercialeDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'creationDate': value['creationDate'] == null ? undefined : ((value['creationDate']).toISOString()),
        'lastmodifiedDate': value['lastmodifiedDate'] == null ? undefined : ((value['lastmodifiedDate']).toISOString()),
        'fkCliente': value['fkCliente'],
        'fkStrutturaBusiness': value['fkStrutturaBusiness'],
        'fkProject': value['fkProject'],
        'fkOpportunity': value['fkOpportunity'],
        'fkUtente': value['fkUtente'],
        'actionDate': value['actionDate'] == null ? undefined : ((value['actionDate']).toISOString().substring(0, 10)),
        'amount': value['amount'],
        'margin': value['margin'],
        'nota': value['nota'],
        'notaEsito': value['notaEsito'],
        'nominativoCliente': value['nominativoCliente'],
        'esito': value['esito'],
        'modalitaContatto': value['modalitaContatto'],
    };
}
